module.exports = __webpack_public_path__ + "img/06.32c90e8c.png";